import React, { Component } from 'react';
import PropTypes
    from 'prop-types';
import {
    Switch,
    InputNumber
} from 'antd';
import 'antd/dist/antd.css';
import PauHelpers
    from './../includes/PauHelpers';
import { pictosPanelHeader } from './../assets/img/panel';
import update
    from 'immutability-helper';
import AccesibilityActions
    from './../includes/AccesibilityActions';
import Cookies
    from 'js-cookie';

class CreateForm extends Component {

    constructor( props ) {

        super( props );

        const { items, header, settings, globals } = props;

        let zoom_pau = 100;

        if ( settings ) {
            zoom_pau = settings.zoom_pau.value
        }

        this.state = {
            items,
            header,
            zoom_pau
        };

    }

    zoomMasMenos( type ) {

        const settings = Cookies.getJSON( "settings" );
        const { zoom_pau } = settings;

        var value = zoom_pau.value;

        if ( type === "mas" ) {
            if ( zoom_pau.value !== 200 ) value += 10;
        } else if ( type === "menos" ) {
            if ( zoom_pau.value !== 70 ) value -= 10;
        }

        let zoomVal = {
            value : { $set : value }
        }

        let dzoom = document.getElementById( "pauDisplayZoom" );
        dzoom.childNodes[ 0 ].textContent = value;

        AccesibilityActions.zoomPanel( value );

        Cookies.remove( "settings" );
        Cookies.set( "settings", update( settings, {
            zoom_pau : zoomVal
        } ) );

        this.setState( update( this.state, {
            zoom_pau : { $set : value }
        } ) );

    }

    strToItems = items => {

        let map = [];

        items.forEach( elem => {

            if ( elem.hasOwnProperty( "group" ) ) {

                map = map.concat( elem.group.map( item => {

                    let val = false;

                    if ( item.key === item.value ) val = true;

                    if ( item.show ) {

                        return <div
                            className={`${item.key} ${item.classes}`}
                            key={item.key}>

                            <span
                                className="pauItemTitle">{item.title}</span>
                            <span
                                className="pauIconPanel"><img
                                src={item.icon}
                                alt={item.title}/></span>
                            <Switch
                                className={item.classes}
                                id={item.id}
                                data-id={item.id}
                                defaultChecked={val}
                                onChange={item.callback}
                            />

                        </div>

                    }

                    return false;

                } ) );

            } else {

                if ( elem.show ) {

                    const key = PauHelpers.normalize( elem.title.replace( / /g, "" ).toLowerCase() );

                    let link = null;

                    if ( elem.hasOwnProperty( "link" ) ) {
                        link = elem.link;
                    }

                    var elementType = this.elementsType( elem.type, elem.title, elem.id, elem.icon, elem.classes, key.replace( /-/g, "" ), elem.value, elem.callback, elem.min, elem.max, link )

                    map.push( elementType );

                }

            }

        } );

        return map;

    }

    elementsType( type, title, id, icon, classes, key, value, callback, min = null, max = null, link = null ) {

        let elem,
            { globals } = this.props,
            { others } = window.reactTranslate;

        switch ( type ) {

            case "switch" :

                elem =
                    <div
                        className={`${key} ${classes}`}
                        key={key}>
                        <span
                            className="pauItemTitle">{title}</span>
                        <span
                            className="pauIconPanel"><img
                            src={icon}
                            alt={title}/></span>
                        <Switch
                            className={classes}
                            id={id}
                            data-id={id}
                            defaultChecked={value}
                            onChange={callback}
                        /> &nbsp;
                    </div>;

                break;

            case "number" :

                elem =
                    <div
                        className={`${key} ${classes}`}
                        key={`${key}-number`}>
                        <span
                            className="pauItemTitle">{title}</span>
                        <span
                            className="pauIconPanel"><img
                            src={icon}
                            alt={title}/></span>
                        <InputNumber
                            min={min}
                            max={max}
                            id={id}
                            data-id={id}
                            style={{ marginLeft : 4 }}
                            defaultValue={value}
                            onChange={callback}
                        />
                    </div>;

                break;

            case "proximamente" :

                elem =
                    <div
                        className={`${key} ${classes}`}
                        key={`${key}-number`}>
                        <span
                            className="pauItemTitle">{title}
                            <strong>({others.comingSoon})</strong></span>
                        <span
                            className="pauIconPanel"><img
                            src={icon}
                            alt={title}/></span>
                    </div>
                break;

            case "link" :

                let tagLink = "";

                if ( link ) {
                    tagLink =
                        <a href={link}
                           target="_blank">
                            {others.togo}
                        </a>;
                }
                elem =
                    <div
                        className={`${key} ${classes}`}
                        key={`${key}-number`}>
                        <span
                            className="pauItemTitle">{title}</span>
                        <span
                            className="pauIconPanel"><img
                            src={icon}
                            alt={title}/></span>
                        {tagLink}
                    </div>
                break;

            case "zoomPau" :

                elem =
                    <div
                        className={`${key} ${classes}`}
                        key={`${key}-number`}>
                        <span
                            className="pauItemTitle">{title}</span>
                        <div
                            id="pauPanelZoom">
                            <span
                                className="iconZoomInside">
                                <img
                                    onClick={this.zoomMasMenos.bind( this, "menos" )}
                                    src={`${pictosPanelHeader( globals.pau_PluginDirUrl ).menos}`}
                                    alt="Botón para disminuir el tamaño del panel"/>
                            </span>
                            <span
                                id="pauPanelZoomPerc">
                                {this.state.zoom_pau}%
                            </span>
                            <span
                                className="iconZoomInside">
                                <img
                                    onClick={this.zoomMasMenos.bind( this, "mas" )}
                                    src={`${pictosPanelHeader( globals.pau_PluginDirUrl ).mas}`}
                                    alt="Botón para aumentar el tamaño del panel"/>
                            </span>
                        </div>
                    </div>
                break;

        }

        return elem;

    }

    render() {

        const { items } = this.state;

        return <React.Fragment>
            {this.strToItems( items )}
        </React.Fragment>

    }

}

CreateForm.propTypes = {
    items : PropTypes.array.isRequired
}

export default CreateForm;



// WEBPACK FOOTER //
// ./src/forms/CreateForm.js